import React from 'react';
import { ThemeProvider } from 'styled-components';
import { MDXProvider } from '@mdx-js/react';
import { preToCodeBlock } from 'mdx-utils';
import Helmet from 'react-helmet';

import Theme from './src/themes/theme';
import { Table, Code } from './src/components';

import 'katex/dist/katex.min.css';
import ContextProvider from './src/context/ContextProvider';
import favicon from './src/images/favicon.ico';

const components = {
  table: Table,
  pre: (preProps) => {
    const props = preToCodeBlock(preProps);
    if (props) return <Code {...props} />;
    return <pre {...props} style={{ color: 'white' }} />;
  },
  wrapper: ({ children }) => <>{children}</>,
};
// Issue has been fixed
export const wrapRootElement = ({ element }) => {
  return (
    <MDXProvider components={components}>
      <Helmet>
        <link rel='icon' href={favicon} />
      </Helmet>
      <ContextProvider>
        <ThemeProvider theme={Theme}>{element}</ThemeProvider>
      </ContextProvider>
    </MDXProvider>
  );
};
